module.exports = __webpack_public_path__ + "static/img/layout1.7c2e07fe.jpg";